import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import { devices } from 'styles/breakpoints';
import { colors } from 'styles/colors';

export const ImageWrapper = styled(Box)`
  height: 56px;
  width: 56px;
  flex-shrink: 0;

  & img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
`;

export const TextWrapper = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  line-height: 140%;
  color: ${colors.mainDark};
  text-align: center;
  max-width: 307px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: 1;
  transform: translateY(0);
  white-space: pre-line;

  @media (${devices.sm}) {
    max-width: 768px;
    min-height: 140px;
  }
`;

export const CarouselContent = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 280px;
  transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
  opacity: 1;
  transform: translateY(0);

  @media (${devices.sm}) {
    min-height: 320px;
  }

  &.fade-enter {
    opacity: 0;
    transform: translateY(20px);
  }

  &.fade-exit {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

export const DotIndicator = styled(Box)<{ isActive: boolean }>`
  margin-left: ${({ isActive }) => (isActive ? 0 : '9px')};
  background: ${({ isActive }) => (isActive ? colors.mainDark : colors.mainGray)};
  height: 8px;
  width: 8px;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  flex-shrink: 0;

  &:hover {
    transform: scale(1.2);
    background: ${colors.mainDark};
  }

  &:first-of-type {
    margin-left: 0;
  }
`;

export const AuthorInfoWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 60px;
  justify-content: center;
  flex-shrink: 0;
`;
